module.exports = __webpack_public_path__ + "img/nightlife.3a5eac2.svg";